import { notify } from 'utils/reduxUtils';

export const types = {
  SHOP_VARIABLES_FETCH_SUCCESS: 'settings/profile/SHOP_VARIABLES_FETCH_SUCCESS',
  SHOP_VARIABLES_VALUES_UPDATE_ERROR:
    'settings/profile/SHOP_VARIABLES_VALUES_UPDATE_ERROR',
  SHOP_VARIABLES_VALUES_UPDATE_REQUEST:
    'settings/profile/SHOP_VARIABLES_VALUES_UPDATE_REQUEST',
  SHOP_VARIABLES_VALUES_UPDATE_SUCCESS:
    'settings/profile/SHOP_VARIABLES_VALUES_UPDATE_SUCCESS',
};

export const shopVariablesFetch = {
  success: ({ quoteDueDateDeltaHours, quoteExpireDateDeltaDays }) => ({
    type: types.SHOP_VARIABLES_FETCH_SUCCESS,
    payload: {
      quoteDueDateDeltaHours,
      quoteExpireDateDeltaDays,
    },
  }),
};

export const shopVariablesValuesUpdate = {
  error: notify(
    (error) => ({
      type: types.SHOP_VARIABLES_VALUES_UPDATE_ERROR,
      payload: error,
    }),
    'Failed to update shop variables.',
  ),
  request: ({
    quoteDueDateDeltaHours,
    quoteExpireDateDeltaDays,
    taskDueDateDeltaHours,
  }) => ({
    type: types.SHOP_VARIABLES_VALUES_UPDATE_REQUEST,
    payload: {
      quoteDueDateDeltaHours,
      quoteExpireDateDeltaDays,
      taskDueDateDeltaHours,
    },
  }),
  success: notify(
    ({ quoteDueDateDeltaHours, quoteExpireDateDeltaDays }) => ({
      type: types.SHOP_VARIABLES_VALUES_UPDATE_SUCCESS,
      payload: {
        quoteDueDateDeltaHours,
        quoteExpireDateDeltaDays,
      },
    }),
    'Shop variables updated.',
  ),
};
